export default class SaveClientCarrierNetworkRequest {
    id: number;
    accountId: string;
    carrierIds: number[];
    name: string;
}